// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {ButtonEl} from 'common/components/button';
import {ButtonTheme} from 'common/components/button/constants';
import {InputEl} from 'common/components/input';

import type {RevealableTextEditor} from './index';

export function template(this: RevealableTextEditor) {
  const {isEditing, currText} = this.state;

  return (
    <div sel='.text-editor'>
      {!isEditing ? (
        <div
          sel='.text-wrapper'
          class={{
            'editable-text': !this.attr(`disable-edit`),
            'show-hover': !this.attr(`disable-edit`) && this.attr(`show-hover-state`),
          }}
          on={{click: (ev) => (this.attr(`disable-edit`) ? null : this.helpers.handleEditingStart(ev))}}
          attrs={{elref: `editableTextWrapper`}}
        >
          <slot attrs={{name: `content`}} />
        </div>
      ) : (
        <>
          <InputEl
            attrs={{
              type: `textarea`,
              value: currText,
              placeholder: this.attr(`placeholder`),
              maxlength: this.attr(`max-chars`),
              size: this.attr(`size`),
              elref: `editableTextInput`,
            }}
            params={{
              onInput: this.helpers.handleValueChange,
              onBlur: this.helpers.handleSaveByBlur,
              onKeydown: this.helpers.handleSaveByKeyPress,
            }}
            props={{
              value: currText,
            }}
            hook={{
              insert: this.helpers.handleInputInserted,
            }}
          />
          {!this.attr(`hide-footer`) ? (
            <div sel='.text-editor-footer'>
              <ButtonEl on={{click: this.helpers.handleCancelEdit}}>Cancel</ButtonEl>
              <ButtonEl
                sel='.save-button'
                attrs={{
                  theme: ButtonTheme.Primary,
                  disabled: !this.helpers.textChanged(),
                }}
                on={{click: this.helpers.handleSaveByButton}}
              >
                Save
              </ButtonEl>
            </div>
          ) : null}
        </>
      )}
    </div>
  );
}
